import React, { useEffect, useState } from "react";
import type { ParentActionsView } from "./ParentActionsSubnav";

interface ParentActionsViewCacheProps {
  activeView: ParentActionsView;
  openActions: React.ReactNode;
  schoolTasks: React.ReactNode;
}

const activeClassName =
  "motion-safe:animate-[lumenPortalScreenSlideIn_420ms_cubic-bezier(0.22,1,0.36,1)_both]";

export default function ParentActionsViewCache({
  activeView,
  openActions,
  schoolTasks,
}: ParentActionsViewCacheProps) {
  const [schoolTasksVisited, setSchoolTasksVisited] = useState(
    activeView === "school-tasks",
  );

  useEffect(() => {
    if (activeView === "school-tasks") setSchoolTasksVisited(true);
  }, [activeView]);

  return (
    <>
      <div
        hidden={activeView !== "open"}
        className={activeView === "open" ? activeClassName : undefined}
        data-testid="open-actions-view"
      >
        {openActions}
      </div>
      {schoolTasksVisited && (
        <div
          hidden={activeView !== "school-tasks"}
          className={activeView === "school-tasks" ? activeClassName : undefined}
          data-testid="school-tasks-view"
        >
          {schoolTasks}
        </div>
      )}
      <style>{`
        @keyframes lumenPortalScreenSlideIn {
          from { opacity: 0; transform: translateX(32px); }
          to { opacity: 1; transform: translateX(0); }
        }
      `}</style>
    </>
  );
}
